/* eslint-disable key-spacing */
<template>
  <transition name="cover">
    <div class="welpage">
      <img class="shuiyin" src="../assets/xxqg/shuiyin.png" alt="">
      <img class="img" src="../assets/xxqg/img.png" alt="">
      <img class="logo" src="../assets/xxqg/logo.png" alt="">
      <img class="text" src="../assets/xxqg/text.png" alt="">
      <p class="vizen">微景天下技术支持</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'xuexiqiangguo',
  data () {
    return {}
  },
  mounted () {
    setTimeout(() => {
      this.hidePage()
    }, 4000)
  },
  methods: {
    hidePage () {
      this.$emit('hidePage')
    }
  }
}
</script>

<style lang="scss">
  @function rem($px) {
    @return $px*(1/25)*1rem;
  }
  @keyframes myanimation {
    0%   {transform: scale(1);}
    25%  {transform: scale(1.1);}
    50%  {transform: scale(1);}
    100% {transform: scale(0.9);}
  }
  $animationTime: 0.6s;

  .welpage{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: linear-gradient(180deg, #FFF5E2 0%, #F3D9B0 100%);;
    z-index: 1;
    &.cover-leave-to {
      opacity: 0;
    }
    &.cover-leave-active {
      transition: opacity $animationTime;
    }
    .shuiyin{
      width: rem(500);
      height: rem(500);
      position: absolute;
      left: 50%;
      bottom: rem(-80);
      transform: translateX(-50%);
    }
    .logo{
      width: rem(171);
      height: rem(43);
      position: absolute;
      left: 50%;
      top: rem(12);
      transform: translateX(-50%);
    }
    .text{
      width: rem(90);
      height: rem(229);
      position: absolute;
      left: rem(35);
      top: rem(91);
    }
    .img{
      width: rem(638 / 2);
      height: rem(906 / 2);
      position: absolute;
      right: 0;
      bottom: rem(38);
    }
    .vizen{
      width: 100%;
      font-size: rem(12);
      color: #666666;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: rem(22);
    }
  }
</style>
